import type { ReactNode } from 'react';

interface RepoListErrorProps {
  onRetry: () => void;
}

/**
 * S-UI-002: Error state with a Retry button.
 */
export function RepoListError({ onRetry }: RepoListErrorProps): ReactNode {
  return (
    <div data-testid="repo-list-error" className="repo-list-error">
      <span>Failed to load repositories — refresh to retry.</span>
      <button
        type="button"
        className="repo-list-error__retry"
        onClick={onRetry}
        aria-label="Retry loading repositories"
      >
        Retry
      </button>
    </div>
  );
}
